import { Button, Image, Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import styled, { css } from 'styled-components';

export default function UploadImage({ props }) {
  function imageClick() {
    document.getElementById('image').click();
  }

  const handleDeleteThumbnail = () => {
    props.setImage('');
    if (props.currentImageUrl) {
      props.setImageUrl('');
    }
  };

  return (
    <>
      <Modal
        visible={props.imagePopupIsOpen}
        title='Upload Image'
        onOk={props.uploadNewImage}
        onCancel={props.toggleImagePopup}
        footer={[
          <Button key='back' onClick={props.toggleImagePopup}>
            Return
          </Button>,
          <Button type='primary' key='submit' className={'btn btn-success'} loading={props.loading} onClick={props.uploadNewImage}>
            Submit
          </Button>,
        ]}
      >
        {!props.imageFile && props.currentImageUrl && (
          <div className='relative'>
            <label>Current Image</label>
            <DeleteBtn>
              <CloseOutlined className='text-right pointer' onClick={handleDeleteThumbnail} />
            </DeleteBtn>
            <div className={`w-100percent pt-1 mb-3`}>
              <Image src={props.currentImageUrl || ''} width={200} />
            </div>
          </div>
        )}

        <div className={'w-100percent pt-1 relative'}>
          <button onClick={imageClick}>Choose File</button>
          <span className='ml-2'>{props.imageFile?.name || 'No file chosen'}</span>
          <input
            type='file'
            id='image'
            name='filename'
            value=''
            hidden
            accept='image/png, image/gif, image/jpeg'
            onChange={(e) => {
              props.setImage(e.target.files[0]);
            }}
          />
          {props.imageFile && (
            <DeleteBtn chooseFile>
              <CloseOutlined className='text-right pointer' onClick={handleDeleteThumbnail} />
            </DeleteBtn>
          )}
        </div>
      </Modal>
    </>
  );
}

const DeleteBtn = styled.div`
  position: absolute;
  ${(props) =>
    props.chooseFile
      ? css`
          right: 10px;
          top: 5px;
        `
      : css`
          left: 210px;
          top: 20px;
        `}

  color: red;
`;
